export function getFundingAccountStatusV2(send) {
  return (fundingAccountStatusId, ...args) =>
    send(
      {
        path: '/v2/fundingAccounts/status/{fundingAccountStatusId}',
        pathParameters: { fundingAccountStatusId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
